import {
  GET_AI_TRAINING,
  GET_AI_TRAINING_SUCCESS,
  GET_AI_TRAINING_FAIL,
  GET_AI_TRAINING_BY_ID,
  GET_AI_TRAINING_BY_ID_SUCCESS,
  GET_AI_TRAINING_BY_ID_FAIL,
  GET_AI_TRAINING_CATEGORIES,
  GET_AI_TRAINING_CATEGORIES_SUCCESS,
  GET_AI_TRAINING_CATEGORIES_FAIL,
  UPSERT_AI_TRAINING,
  UPSERT_AI_TRAINING_SUCCESS,
  UPSERT_AI_TRAINING_FAIL,
  DELETE_AI_TRAINING,
  DELETE_AI_TRAINING_SUCCESS,
  DELETE_AI_TRAINING_FAIL,
  RESET_AI_TRAINING_FLAG,
} from "./actionTypes"

const INIT_STATE = {
  lstAiTraining: [],
  categories: [],
  selectedItem: null,
  error: "",
  success: "",
  loading: false,
}

const AiTraining = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Get All AI Training Data
    case GET_AI_TRAINING:
      return {
        ...state,
        loading: true,
      }

    case GET_AI_TRAINING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        lstAiTraining: action.payload,
      }

    case GET_AI_TRAINING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Get AI Training By ID
    case GET_AI_TRAINING_BY_ID:
      return {
        ...state,
        loading: true,
      }

    case GET_AI_TRAINING_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        selectedItem: action.payload,
      }

    case GET_AI_TRAINING_BY_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Get Categories
    case GET_AI_TRAINING_CATEGORIES:
      return {
        ...state,
      }

    case GET_AI_TRAINING_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
      }

    case GET_AI_TRAINING_CATEGORIES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    // Upsert (Create/Update)
    case UPSERT_AI_TRAINING:
      return {
        ...state,
        loading: true,
      }

    case UPSERT_AI_TRAINING_SUCCESS:
      const { data, isUpdate } = action.payload
      if (isUpdate) {
        return {
          ...state,
          loading: false,
          error: "",
          lstAiTraining: state.lstAiTraining.map(item =>
            item.id === data.id ? data : item
          ),
          success: "داده آموزشی با موفقیت به‌روزرسانی شد",
        }
      }
      return {
        ...state,
        loading: false,
        error: "",
        lstAiTraining: [data, ...state.lstAiTraining],
        success: "داده آموزشی با موفقیت ایجاد شد",
      }

    case UPSERT_AI_TRAINING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Delete
    case DELETE_AI_TRAINING:
      return {
        ...state,
        loading: true,
      }

    case DELETE_AI_TRAINING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        lstAiTraining: state.lstAiTraining.filter(
          item => item.id !== action.payload
        ),
        success: "داده آموزشی با موفقیت حذف شد",
      }

    case DELETE_AI_TRAINING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Reset Flag
    case RESET_AI_TRAINING_FLAG:
      return {
        ...state,
        error: "",
        success: "",
      }

    default:
      return state
  }
}

export default AiTraining
